export default __webpack_public_path__ + "static/media/MISTRZ_SKOCZNOSCI.9ec1e521.png";